<div id="headerSection" *ngIf="showHeader" class="app-header">

  <!-- LEFT SECTION -->
  <div class="header-left">
     <div [ngClass]="{'disabled': clientInstructionRestriction == true}" id="menu" class="menu-icon"  
     (click)="ToggleMenu()">
      <span class="footer-i">
        <i class="fa fa-bars ft-22 menu-i" aria-hidden="true"></i>
      </span>
    </div>
    <app-menu *ngIf="DisplayMenu" [DisplayMenu]="DisplayMenu" (Toggle)="ToggleMenu()"></app-menu>
    <img *ngIf="!loginservice.isHideGebbsLogo" src="assets/images/logo_156.png" class="logo-img" />
<!-- 
    <div class="title-wrapper">
      <span class="page-title">
        <img *ngIf="isCiiNRALogo" src="assets/images/CiiNRA_logo.png" class="sub-logo" />
      </span>
    </div> -->
  </div>

  <!-- CENTER (Marquee) -->
  <div *ngIf="instructionCount > 0" class="header-center" style="left: 28% !important;top: 58% !important;position: absolute;">
    <div class="marquee-text blink">
      <b class="red">Attention</b> :
      There is an update. Kindly check the client instruction screen.
    </div>
  </div>

  <!-- page title set to center -->
  <div class="page-title relative" style="top:-6px;">
     <b>{{ title }}</b>
        <span *ngIf="activeReasonBucket">
          ({{ activeReasonBucket }})
        </span>
        <img *ngIf="isCiiNRALogo" src="assets/images/CiiNRA_logo.png" class="sub-logo" />
  </div>

  <!-- RIGHT SECTION -->
  <div class="header-right">

    <div class="btn-primary-global priorityBtn" *ngIf="route?.url=='/agent/agent' && isMyInbox" (click)="openInboxModal()">
      iDMS
    </div>

    <div class="btn-primary-global priorityBtn" *ngIf="route?.url=='/agent/agent' && isMyInbox" (click)="openProjectAndPriorityModal()">
      Project & Priorities
      <span class="count">
        {{ projectList?.length || 0 }}
      </span>
    </div>

    <!-- Profile -->
   <p-splitButton label="Save" (onClick)="save('info')" severity="contrast" [model]="items" >
      <ng-template pTemplate="content">
        <span class="flex align-items-center font-bold">
          <i class="fa-regular fa-circle-user" style="position: relative;right: 5px;font-size: 14px;" pTooltip="{{UserData.Full_Name}}" tooltipPosition="bottom"></i>
          <span style="font-size: 14px;" pTooltip="{{UserData.Full_Name}}" tooltipPosition="bottom">{{ getInitials(UserData.Full_Name) }}</span>
        </span>
      </ng-template>
    </p-splitButton>


  </div>
</div>